module.exports = __webpack_public_path__ + "img/axa.697c29ad.jpg";